<div class="unauthorized-container">
  <div class="unauthorized-card">
    <!-- Icon -->
    <div class="icon-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
      </svg>
    </div>

    <!-- Title -->
    <h1>Accès refusé</h1>

    <!-- Message -->
    <p class="message">
      Votre compte <strong>{{ userEmail }}</strong> n'est pas autorisé à accéder à cet environnement.
    </p>

    <p class="info">
      Seuls les membres de l'équipe Befret peuvent accéder aux environnements de développement et d'acceptance.
    </p>

    <!-- Actions -->
    <div class="actions">
      <button class="btn btn-primary" (click)="logout()">
        Se déconnecter
      </button>
    </div>

    <!-- Support Contact -->
    <div class="support-info">
      <p class="text-muted">
        Vous pensez qu'il s'agit d'une erreur ?<br>
        Contactez l'administrateur système de Befret.
      </p>
    </div>
  </div>
</div>
